import React from "react";
import "./Manufacturing_Video.css";
import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";
function Manufacturing_Video() {
  return (
    <section className="manifacturing_section container">
      <div className="title">
        <Common_Title_2 title={<>Experience the Manifacturing Process</>} />
      </div>
      <div className="video_holder">
        <video
          className="video_wrapper"
          autoPlay
          loop
          muted
          controls
          playsInline
          onClick={(e) => e.target.requestFullscreen()}
        >
          <source
            src="/assets/video/home/majestry_manifacturing.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  );
}
export default Manufacturing_Video;